import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Stack } from '@mui/material';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { fetchPeppolMessagesRequest } from '../../../api/peppolMessages/peppolMessagesSlice';
import PeppolMessagesTable from '../components/PeppolMessagesTable';
import TopBar from '../../../components/TopBar';
import FeatureNotSupportedDialog from '../../common/FeatureNotSupportedDialog';

function PeppolMessagesListPage() {
  useDocumentTitle('Peppol Messages List');
  const dispatch = useDispatch();
  const subscription = useSelector((state) => state.org.org.subscription);

  useEffect(() => {
    if (!subscription?.features?.enable_peppol) return;
    dispatch(fetchPeppolMessagesRequest({ url: '/peppol-messages', page: 1, limit: 10 }));
  }, [dispatch]);

  return subscription?.features?.enable_peppol ? (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <TopBar title="Incoming Peppol Documents" />
      <PeppolMessagesTable />
    </Stack>
  ) : (
    <FeatureNotSupportedDialog
      title="Incoming Peppol Documents"
      description={'Receive and process Peppol documents directly from Marmin dashboard.'}
    />
  );
}

export default PeppolMessagesListPage;
